import * as types from './mutation-types'

export default {

    [types.ADD_PERMISSIONS] (state, permissions) {

        if(Array.isArray(permissions)){
            state.permissions = permissions
        }else {
            state.permissions = Object.values(permissions)
        }
    },

    [types.SET_SHOP_PERMISSIONS] (state, shopPermissions) {
        // l'API renvoie [] quand il n'y en a aucune
        state.shopPermissions = shopPermissions && !Array.isArray(shopPermissions) ? shopPermissions : {}
    },

    [types.SET_CONTEXT_SHOP] (state, shopId) {
        state.contextShopId = shopId || null
    },

    [types.SET_PERMISSION_LABELS] (state, labels) {
        state.permissionLabels = labels || {}
    }
}
